const normalizeSvensktPersonnummer = require('./svenskt-personnummer')

const reOrganisationsnummer = /^(\d{2})?(\d{2})(\d{2})(\d{2})[-+]?(\d{4})$/

module.exports = function normalizeSvensktOrganisationsnummer(input) {
  const match = reOrganisationsnummer.exec(input.replace(/\s/g, ''))

  if (!match) return input

  const parts = match.slice(1)
  const [century, year, month, day, digits] = parts

  if (Number(month) < 20) {
    return normalizeSvensktPersonnummer(input)
  }

  if (century === undefined || century === '16') {
    return `16${year}${month}${day}${digits}`
  }

  return input
}
